import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 9 9",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.75 4.5C0.75 4.17895 0.966231 3.75 1.41667 3.75H6.08333C6.53377 3.75 6.75 4.17895 6.75 4.5V7.875C6.75 8.19605 6.53377 8.625 6.08333 8.625H1.41667C0.966231 8.625 0.75 8.19605 0.75 7.875V4.5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.375 1.5C6.96013 1.5 7.5 2.04016 7.5 2.79167V4.125C7.5 4.33211 7.66789 4.5 7.875 4.5C8.08211 4.5 8.25 4.33211 8.25 4.125V2.79167C8.25 1.70223 7.44671 0.75 6.375 0.75C5.30329 0.75 4.5 1.70223 4.5 2.79167V4.125C4.5 4.33211 4.66789 4.5 4.875 4.5C5.08211 4.5 5.25 4.33211 5.25 4.125V2.79167C5.25 2.04016 5.78987 1.5 6.375 1.5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }